import {EnvironmentProperty, GameConfig} from '@gongxigames/framework/slot/types';
import {CoreDI, inject, injectable, IService, LanguageService, SystemComponentType} from '@gongxigames/framework/core';

@injectable()
export class GameInfoService implements IService {
    public static NAME = 'GameInfoService';
    public type: SystemComponentType = 'service';

    @inject(CoreDI.GameConfig)
    protected _gameConfig!: GameConfig;

    @inject(CoreDI.EnvironmentProperty)
    protected _environmentProperty!: EnvironmentProperty;

    @inject(CoreDI.LanguageService)
    protected _languageService!: LanguageService;

    init(): void {
        window.gameInfo = {
            versions: this._environmentProperty.buildProperty.versions,
            rtp: this._gameConfig.RTP,
            winProbability: this._gameConfig.winProbability,
            gameName: this.getGameName()
        };
    }

    // TODO - one logic for this class and WaterMarkModule and JurisdictionZoneModule
    protected getGameName(): string {

        const localizeGameName = this._languageService.get('gameName');
        const str = localizeGameName === 'undefined' ? this._gameConfig.gameName : localizeGameName;

        return str.toUpperCase();
    }
}
